import type { CreateExpenditureRequest, UpdateExpenditureRequest } from '../generated/dtos.gen';

export type ExpenditureUpdateFields = Pick<UpdateExpenditureRequest, 'concurrencyVersion' | 'category' | 'purpose'> &
  Partial<UpdateExpenditureRequest>;

export function updateExpenditureRequest(fields: ExpenditureUpdateFields): UpdateExpenditureRequest {
  return {
    amount: null,
    payeeContactId: null,
    date: null,
    updateDebtLink: false,
    debtId: null,
    updateLoanLink: false,
    loanId: null,
    updateEventDates: false,
    authorizedDate: null,
    incurredDate: null,
    ...fields,
  };
}

export function createExpenditureRequest(
  fields: Pick<CreateExpenditureRequest, 'contactId' | 'amount' | 'date' | 'category' | 'purpose'> &
    Partial<CreateExpenditureRequest>,
): CreateExpenditureRequest {
  return {
    authorizedDate: null,
    incurredDate: null,
    mdExpenseCategory: null,
    mdExpensePurpose: null,
    bankTransactionId: null,
    debtId: null,
    loanId: null,
    ...fields,
  };
}
